import * as ActionTypes from '../ActionTypes';
const initState = {
  
    applicationsList: "",
    applications:[],
    updatedApplication: '',
    response: '',
    usersListByRole: [],
    relays:[],
    user: '',
   
};

const ApplicationReducer = (state = initState, action) => {
    switch (action.type) {

       

        case ActionTypes.LOAD_APPLICATIONS_LIST_SUCCESS:
            return {
                ...state,
                applicationsList: action.res,
                applications: action.res.data
            };

        case ActionTypes.LOAD_APPLICATIONS_LIST_ERROR:
            return {
                ...state,
                applicationsList: action.res,
                applications: action.res.data
            };
        case ActionTypes.UPDATE_APPLICATION_SUCCESS:
            return {
                ...state,
                applicationsList: action.res,
                applications: action.res.data,
                updatedApplication: action.res.updatedApplication
            };

        case ActionTypes.UPDATE_APPLICATION_ERROR:
            return {
                ...state,
                applicationsList: action.res,
                applications: action.res.data
            };
        case ActionTypes.STORE_RELAY_SUCCESS:
            return {
                ...state,
                response: action.res,
                relays: action.res.data,
                user: action.res.user
            };

        case ActionTypes.STORE_RELAY_ERROR:
            return {
                ...state,
                response: action.res,
                relays: action.res.data,
                user: action.res.user
            };

            
        case ActionTypes.USERS_LIST_BY_ROLE_SUCCESS:
            return {
                ...state,
                response: action.res,
                usersListByRole: action.res.data,
                user: action.res.user
            };

        case ActionTypes.USERS_LIST_BY_ROLE_ERROR:
            return {
                ...state,
                response: action.res,
                usersListByRole: action.res.data,
                user: action.res.user
            };
        case ActionTypes.CODE_ERROR:
            return {
                ...state,
                applicationsList:
                    "There seems to be a problem, please refresh your browser",
            };

        default:
            return state;
    }
};

export default ApplicationReducer;
